export default __webpack_public_path__ + "static/media/logo.8a665a24.svg";